export enum AccountFilters {
  corporateOnly = "corporateOnly",
  testOnly = "testOnly",
  notTestOnly = "notTestOnly",
  accountsOnly = "accountsOnly",
}
